import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CssBaseline, Grid, Snackbar } from "@mui/material";
import { Scrollbars } from "react-custom-scrollbars-2";

import {
  mainLayoutStyles,
  routes,
  showNotification,
  GeneralAdminRoutes,
} from "../../../../../constants";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import { Toast } from "../../../../../common/alert";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../hooks";
import {
  contributorsSearch,
  searchUsersFromFirebase,
} from "../../../../../modules/Contributors/hooks/ContributorsHook";
import { useAdminsContext } from "../../../../../providers/OrganizationAdmin/AdminsProvider";
import {
  addAdmin,
  checkAdminExist,
  updateAdmin,
} from "../../../../../modules/Admins/hooks/AdminsHook";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  AddAdminSendInviteModal,
  AddAdminTable,
  SearchBar,
} from "../../../../../modules/Admins/components/components";
import { sendgridEmail } from "../../../../../modules/AreaManagement/hooks/AreaHook";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import { getEmailTemplate } from "../../../../../emails/EmailTemplate";
import { useContributorsContext } from "../../../../../providers/OrganizationAdmin/ContributorsProvider";
import getNotifyAdminEmailTemplate from "../../../../../emails/NotifyAdminEmailTemplate";

const AddAdminUserContainer = () => {
  const { currentUser } = useAuth();
  const { handleGetGAAdmins, setLoading, loading } = useAdminsContext();
  const { GAUsers, handleGetAllGAUsers } = useContributorsContext();
  const navigate = useNavigate();

  const scrollbarsRef = useRef(null);
  const [admins, setAdmins] = useState([]);
  const [selected, setSelected] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [addAdminSendInviteModal, setAddAdminSendInviteModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snakbarMessgae, setSnakbarMessgae] = useState("");
  const [userData, setUserData] = useState(null);
  const [confirmInviteModal, setConfirmInviteModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);

  useEffect(() => {
    handleGetAllGAUsers();
  }, []);

  const handleCancelModalOpen = () => {
    setCancelModal(true);
  };
  const handleCancelModalClose = () => {
    setCancelModal(false);
  };
  const handleCancel = () => {
    try {
      setLoading(true);
      handleCancelModalClose();
      navigate(GeneralAdminRoutes.adminUsers);
      setLoading(false);
    } catch (error) {
      console.log("handleCancel error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendInviteModalOpen = () => {
    setAddAdminSendInviteModal(true);
  };
  const handleSendInviteModalClose = () => {
    setAddAdminSendInviteModal(false);
  };

  const handleConfirmInviteModalOpen = (userData) => {
    setUserData(userData);
    setConfirmInviteModal(true);
  };
  const handleConfirmInviteModalClose = () => {
    setUserData(null);
    setConfirmInviteModal(false);
  };

  const handleSearchUsers = async (e) => {
    try {
      const searchTerm = e.target.value;
      setSearchValue(e.target.value);
      if (searchTerm.trim() === "") {
        setAdmins([]);
        setSearchValue(null);
      } else {
        let usersSearchTemp = await contributorsSearch(GAUsers, searchTerm);
        console.log("searched:", usersSearchTemp);
        setAdmins(usersSearchTemp);
      }
    } catch (error) {
      console.log("error searching users:", error.message);
    }
    // const searchTerm = e.target.value;
    // setSearchValue(e.target.value);
    // // const searchTerm = e.target.value.toLowerCase();
    // if (searchTerm.trim() === "") {
    //   setAdmins([]);
    //   setSearchValue(null);
    //   return;
    // }

    // try {
    //   let users = await searchUsersFromFirebase(searchTerm);
    //   console.log("searched users::", users);
    //   setAdmins(users);
    // } catch (error) {
    //   console.error("error searching users:", error.message);
    // }
  };

  const handleMakeAdmins = async () => {
    try {
      if (selected.length) {
        setLoading(true);
        // Filter out the selected users'
        const selectedUsersDetails = admins
          .filter((user) => selected.includes(user.id))
          .map((userRecord) => userRecord);

        for (const userData of selectedUsersDetails) {
          await handleAddUserAsAdmin(userData);
        }
        await handleGetGAAdmins();
        // Toast("success", "Selected user(s) have been added as admin(s)");
        showNotification("Selected user(s) have been added as admin(s)");
        navigate(-1);
      } else {
        Toast("error", "Select User.");
      }
    } catch (error) {
      console.log("error making admin:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddUserAsAdmin = async (userData) => {
    try {
      setLoading(true);
      let dataTemp = {
        firstName: userData.firstName ?? "",
        lastName: userData.lastName ?? "",
        userName: userData.userName ?? "",
        photoUrl: userData.photoUrl ?? "",
        email: userData.email ?? "",
        userId: userData.id ?? "",
        createdAt: new Date(),
        phone: userData.phone ?? "",
        type: "general",
        role: "standard",
        status: "active",
      };

      let response = await addAdmin(dataTemp);
      // const htmlContentToNotifyAdmin = getNotifyAdminEmailTemplate(
      //   userData,
      //   true,
      //   currentOrganization?.name
      // );
      const htmlContentToNotifyAdmin = getNotifyAdminEmailTemplate(
        userData,
        false,
        ""
      );

      const message = {
        to: userData.email,
        from: process.env.REACT_APP_FROM_EMAIL,
        subject: "Added as Admin on QuickTales",
        html: htmlContentToNotifyAdmin,
      };
      let responseTemp = await sendgridEmail(message);
      if (responseTemp) {
        setSnakbarMessgae("Invitation Sent!");
        setSnackbarOpen(true);
      }
      console.log("added admin successfully.", response);
      showNotification("Admin Added successfully");
    } catch (error) {
      console.log("error adding admin:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSendInvite = async () => {
    let name = userData.name;
    let text = userData.message;
    try {
      setLoading(true);
      let dataTemp = {
        firstName: userData.name,
        userName: userData.name,
        email: userData.email,
        createdAt: new Date(),
        type: "general",
        role: "standard",
        status: "inactive",
      };

      let id = null;

      let userExist = await checkAdminExist(userData.email);
      if (userExist.status) {
        const response = await updateAdmin(userExist.id, dataTemp);
        id = userExist.id;
      } else {
        const response = await addAdmin(dataTemp);
        id = response.id;
      }

      let redirectUrl = window.location.origin + "/accept-admin-invite";
      redirectUrl = redirectUrl + "/" + id + "/accepted";
      const htmlContent = getEmailTemplate(userData, "Admin", redirectUrl);

      const message = {
        to: userData.email,
        from: process.env.REACT_APP_FROM_EMAIL,
        subject: "Admin Invite",
        html: htmlContent,
      };

      let responseTemp = await sendgridEmail(message);
      if (responseTemp) {
        handleSendInviteModalClose();
        setSnakbarMessgae("Invitation Sent!");
        setSnackbarOpen(true);
      }
      await handleGetGAAdmins();
      showNotification("Selected user have been added as admin");
      // Toast("success", "Selected user have been added as admin");
      navigate(-1);
    } catch (error) {
      console.log("error sending invitation:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"Add Admin"}
        bgColor="#fff"
        buttonText={"Add Admin"}
        submitButtonText={"Make Admin"}
        editEnabled={true}
        cancelButton={true}
        onCancelClick={() => handleCancelModalOpen()}
        handleSave={() => handleMakeAdmins()}
        loading={loading}
      />
      <GeneralAdminSidebar />
      <Snackbar
        // anchorOrigin={{ vertical, horizantal }}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snakbarMessgae}
        // key={vertical + horizantal}
      />
      <Grid
        container
        style={{ ...mainLayoutStyles, background: "#fff", paddingTop: 80 }}
      >
        <Grid container direction={"column"}>
          <SearchBar handleSearch={handleSearchUsers} />

          {admins.length && admins.length > 0 ? (
            <Scrollbars
              style={scrollbar}
              autoHide={true}
              ref={scrollbarsRef} // Assign the ref to Scrollbars instance
              renderThumbVertical={({ style, ...props }) => (
                <div
                  {...props}
                  style={{
                    ...style,
                    ...scrollbarprops,
                  }}
                />
              )}
            >
              <AddAdminTable
                admins={admins}
                selected={selected}
                setSelected={setSelected}
              />
            </Scrollbars>
          ) : searchValue ? (
            <Grid
              container
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              style={{ height: "80vh" }}
            >
              <span style={{ fontFamily: "Avenir Book, sans-serif" }}>
                No Results for ‘{searchValue}’
              </span>
              <Button
                variant="text"
                onClick={handleSendInviteModalOpen}
                style={{
                  color: "#00A7CD",
                  fontSize: 14,
                  fontWeight: 700,
                  textTransform: "none",
                  fontFamily: "Avenir Book, sans-serif",
                }}
              >
                Send Invite
              </Button>
            </Grid>
          ) : undefined}
        </Grid>
      </Grid>
      <AddAdminSendInviteModal
        modalOpen={addAdminSendInviteModal}
        handleClose={handleSendInviteModalClose}
        handleSendInvite={handleConfirmInviteModalOpen}
        loading={loading}
      />
      <ConfirmationModal
        modalOpen={confirmInviteModal}
        handleClick={handleSendInvite}
        title={"Would you like to submit this admin invite?"}
        handleClose={handleConfirmInviteModalClose}
        loading={loading}
      />
      <ConfirmationModal
        open={cancelModal}
        onClose={handleCancelModalClose}
        onConfirm={handleCancel}
        title={"Are you sure to Cancel adding new admin user?"}
      />
    </Box>
  );
};

export default AddAdminUserContainer;

const scrollbar = { width: "100%", height: "530px", marginLeft: "auto" };
const scrollbarprops = {
  width: "4px",
  backgroundColor: "#00A7CD",
  borderRadius: "2px",
};
